import { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function OAuthSuccess() {
  const { refreshAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  const [authCompleted, setAuthCompleted] = useState(false);

  useEffect(() => {
    const finalizeLogin = async () => {
      try {
        await refreshAuth(); // Fetch and update state
        setAuthCompleted(true); // Trigger navigation in next effect
      } catch (err) {
        console.error("OAuth finalization failed:", err);
        navigate("/login?error=oauth_failed");
      }
    };

    finalizeLogin();
  }, [refreshAuth, navigate]);

  useEffect(() => {
    if (authCompleted) {
      navigate("/", { replace: true });
    }
  }, [authCompleted, navigate]);

  return (
    <div className="page-shell flex items-center justify-center px-4">
      <div className="ui-card max-w-md px-8 py-10 text-center">
        <p className="text-2xl font-bold text-secondary mb-3">Completing sign in...</p>
        <p className="text-textMuted">Please wait while we log you in.</p>
      </div>
    </div>
  );
}